import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.014 16" width="1em" height="1em" {...props}><g fill="#474747"><path d="M5.514 6.014c-.822 0-1.5.678-1.5 1.5 0 .823.678 1.5 1.5 1.5.823 0 1.5-.677 1.5-1.5 0-.822-.677-1.5-1.5-1.5zm0 1c.282 0 .5.218.5.5 0 .282-.218.5-.5.5a.493.493 0 01-.5-.5c0-.282.218-.5.5-.5zm-5 3v1h1.213l1.75 3h2.037v-1H4.051l-1.75-3zm14-1c-.822 0-1.5.678-1.5 1.5 0 .823.678 1.5 1.5 1.5.823 0 1.5-.677 1.5-1.5 0-.822-.677-1.5-1.5-1.5zm0 1c.282 0 .5.218.5.5 0 .282-.218.5-.5.5a.493.493 0 01-.5-.5c0-.282.218-.5.5-.5z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" /><path d="M.514 7.014v1h1.213l1.75 3h9.787v-1H4.051l-1.75-3zm0-3v1h3.004l1.043 1.672.848-.531-1.336-2.14zm2.03-2.996v1l2.687.002.605 1.002.856-.516-.897-1.486z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" /><path d="M11.446 10.262l-.863.504 1.125 1.938.863-.504zm-2.998.002l-.867.5 1.156 2 .867-.5zm-2.985.031l-.898.438.969 2 .898-.438z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" /><path d="M9.014.014v1h-1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h-1v-1h-1v1h-1v-1h-1v1h-1v-1z" /><path d="M12.514 12.014c-.822 0-1.5.678-1.5 1.5 0 .823.678 1.5 1.5 1.5.823 0 1.5-.677 1.5-1.5 0-.822-.677-1.5-1.5-1.5zm0 1c.282 0 .5.218.5.5 0 .282-.218.5-.5.5a.493.493 0 01-.5-.5c0-.282.218-.5.5-.5zm-3-1c-.822 0-1.5.678-1.5 1.5 0 .823.678 1.5 1.5 1.5.823 0 1.5-.677 1.5-1.5 0-.822-.677-1.5-1.5-1.5zm0 1c.282 0 .5.218.5.5 0 .282-.218.5-.5.5a.493.493 0 01-.5-.5c0-.282.218-.5.5-.5zm-3-1c-.822 0-1.5.678-1.5 1.5 0 .823.678 1.5 1.5 1.5.823 0 1.5-.677 1.5-1.5 0-.822-.677-1.5-1.5-1.5zm0 1c.282 0 .5.218.5.5 0 .282-.218.5-.5.5a.493.493 0 01-.5-.5c0-.282.218-.5.5-.5zm-5-13c-.822 0-1.5.678-1.5 1.5 0 .823.678 1.5 1.5 1.5.823 0 1.5-.677 1.5-1.5 0-.822-.677-1.5-1.5-1.5zm0 1c.282 0 .5.218.5.5 0 .282-.218.5-.5.5a.493.493 0 01-.5-.5c0-.282.218-.5.5-.5z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" /></g></svg>;
}

export default SvgComponent;